import {useEffect, useState} from "react";

import {useGetOfferDetailApplicationQuery} from "../../../offer/api/get_offer_detail";
import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {useGetPropertyDetailApplicationQuery} from "../../../property/api/get_property_detail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {useRecommendationsExcludingSentApplications} from "./use_application_multi_lead_recommendations_excluding_sent";

interface IProps {
    propertyId?: IPropertyDetail["id"] | null;
    offerId?: IOfferDetail["id"] | null;
    excludedOfferIds?: number[];
}

export const useMultiLeadRecommendations = (props: IProps) => {
    const {propertyId, offerId, excludedOfferIds} = props;
    const [distanceInKm, setDistanceInKm] = useState<number>(recommendationsDistanceInKm);

    const {
        data: propertyDetail,
        isLoading: propertyLoading,
        isUninitialized: propertyUninitialized
    } = useGetPropertyDetailApplicationQuery(propertyId || 0, {skip: !propertyId});

    const {data: offerDetail, isLoading: offerLoading, isUninitialized: offerUninitialized} = useGetOfferDetailApplicationQuery(offerId || 0, {skip: !offerId});

    const {results: recommendations, isLoading: recommendationsLoading} = useRecommendationsExcludingSentApplications({
        offer: offerDetail,
        property: propertyDetail,
        distanceInKm,
        skip: !offerDetail,
        offersToExclude: excludedOfferIds
    });

    const detailsUninitialized = propertyUninitialized || offerUninitialized;
    const areRecommendationsLoading = recommendationsLoading || propertyLoading || offerLoading || detailsUninitialized;
    const hasNoRecommendations = !recommendationsLoading && recommendations && !recommendations.length;

    useEffect(() => {
        if (!recommendationsLoading && hasNoRecommendations && distanceInKm === recommendationsDistanceInKm) {
            setDistanceInKm(5);
        }
    }, [recommendations, distanceInKm, recommendationsLoading]);

    return {
        areRecommendationsLoading,
        recommendedProperties: propertyId ? (recommendations as IRecommendedProperty[]) : [],
        recommendedOffers: !propertyId ? (recommendations as IRecommendedOffer[]) : [],
        areRecommendationsEmpty: !areRecommendationsLoading && recommendations.length === 0
    };
};
